import React from "react";
import { useTranslation } from "react-i18next";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import { IconButton, Tooltip } from "@outpave/ds";
import { HugeiconsIcon } from "@hugeicons/react";
import {
  Copy01Icon,
  LinkSquare02Icon,
} from "@hugeicons-pro/core-stroke-rounded";

interface PaymentLinkCopyRowProps {
  url: string;
  onCopy: () => void;
}

const PaymentLinkCopyRow: React.FC<PaymentLinkCopyRowProps> = ({
  url,
  onCopy,
}) => {
  const { t } = useTranslation();

  return (
    <Box
      sx={{ display: "flex", flexDirection: "column", gap: "var(--space-2)" }}
    >
      <Typography variant="caption" color="var(--color-text-tertiary)">
        {t("Public link")}
      </Typography>

      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          gap: "var(--space-2)",
          padding: "var(--space-2) var(--space-3)",
          borderRadius: "var(--radius-md)",
          border: "var(--border-width-1) solid var(--color-border)",
        }}
      >
        <Typography
          variant="body2"
          sx={{
            flex: 1,
            overflow: "hidden",
            textOverflow: "ellipsis",
            whiteSpace: "nowrap",
          }}
        >
          {displayUrl(url)}
        </Typography>

        <Tooltip title={t("Open")}>
          <IconButton
            variant="ghost"
            href={url}
            target="_blank"
            rel="noopener noreferrer"
            aria-label={t("Open")}
          >
            <HugeiconsIcon icon={LinkSquare02Icon} size={16} />
          </IconButton>
        </Tooltip>
        <Tooltip title={t("Copy")}>
          <IconButton variant="ghost" onClick={onCopy} aria-label={t("Copy")}>
            <HugeiconsIcon icon={Copy01Icon} size={16} />
          </IconButton>
        </Tooltip>
      </Box>
    </Box>
  );
};

function displayUrl(url: string) {
  return url.replace(/^https?:\/\//, "");
}

export default PaymentLinkCopyRow;
